import { render, staticRenderFns } from "./FollowersModal.vue?vue&type=template&id=87774d2e&"
import script from "./FollowersModal.vue?vue&type=script&lang=js&"
export * from "./FollowersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports